import styled, { css } from '@xstyled/styled-components'

export const ProductDetailsWrapper = styled.div`
  ${({ theme }) => css`
    margin: 0 auto;
    font-family: var(--sans);
    text-align: right;
    h1 {
      font-family: var(--sans);
      flex: 0;
    }
    display: block;
    align-self: center;

    ${theme.mediaQueries.desktop} {
      text-align: right;
      width: 450px;
      min-width: 360px;
      padding: calc(${theme.navHeight} + ${theme.space[9]}px) 8 6;
    }
  `}
`

export const ProductHeader = styled.header`
  text-align: right;
  h1 {
    margin: 0;
    font-size: 2;
  }
  span {
    font-weight: 700;
    font-size: 2;
  }
  @media screen and (max-width: 1024px) {
    text-align: left;
    h1,
    span {
      font-size: 4;
      max-width: 480px;
    }
  }
`

export const ProductBody = styled.div`
  font-family: var(--serif);
  letter-spacing: -1px;
  ul {
    list-style-type: none;
    text-align: left;
  }
  li {
    margin-bottom: 0.5em;
    position: relative;
  }
  li:before {
    content: '☆';
    margin-right: 1em;
    margin-left: -2em;
    position: absolute;
    left: 0;
  }
  @media screen and (max-width: 1024px) {
    p {
      font-size: 6;
      letter-spacing: -0.25px;
      max-width: 480px;
      margin-right: auto;
      text-align: left;
    }
    ul {
      max-width: 480px;
      font-size: 12px;
      letter-spacing: -0.2px;
      margin-top: 2em;
      margin-left: auto;
      text-align: left;
    }
  }
`
export const OptionWrapper = styled.div`
  margin-bottom: 4;
  .options-group {
    display: none;
  }
  &:hover .options-group {
    display: flex;
  }
  .preview {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 3;
    border: 1px solid black;
    background-color: lightGray;
    font-family: var(--serif);
    font-size: 4;
  }
  .preview p {
    font-size: 4;
    margin: 0;
  }
  .color-swatch {
    display: inline-block;
    width: 40px;
    height: 40px;
    border: 1px solid black;
  }
  #moss {
    background-color: #a8bfa1;
  }
  #white {
    background-color: white;
  }
  #aqua {
    background-color: #a8d0d1;
  }
  #olive {
    background-color: #556b2f;
  }
  #slate {
    background-color: #a7cad4;
  }
  @media screen and (max-width: 1024px) {
    .preview {
      padding: 2;
      font-size: 5;
    }
    .preview p {
      font-size: 5;
    }
    .color-swatch {
      width: 40px;
      height: 40px;
    }
    .options-group button {
      font-size: 5;
      height: 40px;
    }
  }
`

export const BuyButtonWrapper = styled.div`
  margin-top: 3;
  button:disabled,
  button[disabled] {
    background-color: lightGray;
  }
`
